/** Icons generated by create-react-s. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function AppSwitcher(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M17.0955 12.1235L11.6988 16.4409V16.4409C11.3009 16.7592 10.7273 16.7274 10.367 16.3671L7.63274 13.6329V13.6329C7.27244 13.2726 7.24067 12.699 7.55898 12.3011L11.8764 6.90434V6.90434C13.8506 4.43656 16.8396 3 19.9999 3V3C20.5521 3 20.9999 3.44772 20.9999 4V4.00001C20.9999 7.16031 19.5633 10.1493 17.0955 12.1235L17.0955 12.1235Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13V17.382V17.382C16 17.7608 15.786 18.107 15.4472 18.2764L13.0313 19.4844V19.4844C12.5373 19.7314 11.9366 19.5312 11.6896 19.0372C11.6685 18.9949 11.6504 18.9511 11.6354 18.9062L11 17L16 13ZM7 13L5.09384 12.3646V12.3646C4.5699 12.19 4.28674 11.6236 4.46139 11.0997C4.47635 11.0548 4.49448 11.011 4.51564 10.9687L5.72364 8.55279V8.55279C5.89302 8.21403 6.23925 8.00003 6.618 8H11L7 13ZM5.7501 20.5869L3 21L3.41315 18.2499V18.2499C3.54717 17.3578 4.2475 16.6575 5.13964 16.5235V16.5235C6.26172 16.3549 7.30803 17.1278 7.47664 18.2499C7.50705 18.4523 7.50705 18.6581 7.47664 18.8605V18.8605C7.34259 19.7526 6.64224 20.4529 5.7501 20.5869V20.5869Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

AppSwitcher.defaultProps = {
  color: "currentColor",
  size: 24,
};

AppSwitcher.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
